import TelNumberField from '@/components/fields/tel-number-field.vue';

import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
export default {
    components : {
        TelNumberField
    },
    mixins: [validationMixin],

    validations: {
        email: { required, email },
        formCommunication : ['email']
    },
    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data: () => ({
        formCommunication   : null,
        email               : null,
    }),
    methods : {
        validateForm() {
            this.$v.formCommunication.$touch();
            let errors = false;

            if (this.$refs.numTelefon.required && !this.$refs.numTelefon.validate()) {
                console.error('numTelefon is not valid!');
                errors = true;
            }
            if (this.$refs.numFax.required && !this.$refs.numFax.validate()) {
                console.error('numFax is not valid!');
                errors = true;
            }
            if (this.$refs.numMobile.required && !this.$refs.numMobile.validate()) {
                console.error('numMobile is not valid!');
                errors = true;
            }

            if (errors) {
                this.$emit('form-communication-has-errors');
                return false;
            } else {
                this.$emit('form-communication-is-valid');
                return true;
            }
        },
        onValidateFields() {
            console.warn('onValidateFields', this.$refs);
            if (this.$v.formCommunication.$dirty) {
                this.validateForm();
            } else {
                return;
            }
        },
        resetForm() {
            if (this.$v.formCommunication.$dirty) {
                this.$v.formCommunication.$reset();
                this.$refs.numTelefon.reset();
                this.$refs.numFax.reset();
                this.$refs.numMobile.reset();
                this.email = '';
                this.$emit('form-communication-is-valid');
            }
        },
        getFormValues() {
            let ret = {};

            ret.numTelefon  = this.$refs.numTelefon.getValue();
            ret.numFax      = this.$refs.numFax.getValue();
            ret.numMobile   = this.$refs.numMobile.getValue();
            ret.email       = this.email;

            return ret;
        },
        setFormValues(data) {
            console.info('data', data);
            this.$refs.numTelefon.setValue(data.numTelefon);
            this.$refs.numFax.setValue(data.numFax);
            this.$refs.numMobile.setValue(data.numMobile);
            this.email      = data.email;
        },
    },
    watch: {
        '$v.formCommunication.$anyError' : function(errors) {
            if (errors) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing xxx
                this.$emit('form-communication-has-errors');
            } else {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('form-communication-is-valid');
            }
        },
        '$v.formCommunication.$dirty' : function(dirty) {
            if (!dirty && !this.$v.formCommunication.$anyError) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('form-communication-is-valid');
            } else {
                if (this.$v.formCommunication.$anyError) {
                    // Fire when the form is cleared
                    // @arg The argument is a boolean value representing xxx
                    this.$emit('form-communication-has-errors');
                }
            }
        }
    },
    computed: {
        emailErrors () {
            const errors = [];
            if (!this.$v.email.$dirty) {
                return errors;
            }
            if (!this.$v.email.email) {
                errors.push('Must be valid e-mail');
            }
            if (!this.$v.email.required) {
                errors.push('E-mail is required');
            }
            return errors;
          },
    },
};
